module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "accept.823488d3.png";